<div class="camera" [class.landscape]="isLandscape" [class.recording]="recording"
  [class.alt]="ratio === 'alt'">
  <ng-container *ngIf="!error; else cameraError">

    <!-- Light band behind the feed: makes the letterbox (control tray + the 1:1 margin) visible -->
    <div class="backdrop"></div>

    <!-- Letterboxed frame: the video/preview keeps a fixed 3:4 / 4:3 / 1:1 ratio -->
    <div class="stage">
      <div class="frame" [ngClass]="frameClass">
        <video #video class="feed" [class.hidden]="preview" [class.mirror]="facing === 'user'"
          autoplay playsinline muted></video>
        <img *ngIf="preview && previewKind === 'image'" class="feed" [src]="preview" alt="" />
        <video *ngIf="preview && previewKind === 'video'" class="feed" [src]="preview" controls autoplay
          playsinline></video>
      </div>
    </div>

    <!-- Close (top-left portrait, bottom-left landscape) doubles as "discard preview" -->
    <button type="button" class="icon-btn close" (click)="preview ? discard() : close()">
      <mat-icon>close</mat-icon>
    </button>

    <button type="button" class="icon-btn flash" *ngIf="hasTorch && !preview && !recording" (click)="toggleFlash()">
      <mat-icon>{{ flashOn ? 'flash_on' : 'flash_off' }}</mat-icon>
    </button>

    <!-- Recording timer (top-right portrait, top-left landscape) -->
    <div class="timer" *ngIf="recording">
      <span class="dot"></span>{{ timerLabel }}
    </div>

    <ng-container *ngIf="!preview">
      <!-- Ratio toggle: bordered text badge, same column as the shutter -->
      <button type="button" class="ratio-btn" *ngIf="!recording" (click)="toggleRatio()">
        {{ ratioLabel }}
      </button>

      <!-- Switch camera (bottom-left portrait, bottom-right landscape) -->
      <button type="button" class="icon-btn switch" *ngIf="!recording" (click)="switchCamera()">
        <mat-icon>flip_camera_ios</mat-icon>
      </button>

      <!-- Shutter (bottom-center portrait, right-center landscape) -->
      <button type="button" class="shutter" [class.video]="mode === 'video'" [class.rec]="recording"
        [class.busy]="finalizing" [disabled]="finalizing" *ngIf="!starting" (click)="onShutter()">
        <span class="inner" *ngIf="!finalizing"></span>
        <span class="spinner" *ngIf="finalizing"></span>
      </button>

      <!-- Photo / Video mode selector (bottom bar portrait, right rail landscape) -->
      <div class="mode-bar" *ngIf="!recording">
        <div class="mode-inner">
          <button type="button" class="mode" [class.active]="mode === 'video'" (click)="setMode('video')">
            {{ 'form.video' | translate }}
          </button>
          <button type="button" class="mode" [class.active]="mode === 'photo'" (click)="setMode('photo')">
            {{ 'form.photo' | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Preview actions -->
    <lib-button *ngIf="preview" class="send" [icon]="'send'" [color]="'primary'" (click)="send()"></lib-button>
  </ng-container>

  <ng-template #cameraError>
    <div class="error">
      <mat-icon>videocam_off</mat-icon>
      <span *ngIf="error === 'permission'">{{ 'form.camera_permission' | translate }}</span>
      <span *ngIf="error !== 'permission'">{{ 'form.camera_unavailable' | translate }}</span>
      <lib-button [icon]="'close'" [color]="'secondary'" (click)="close()"></lib-button>
    </div>
  </ng-template>
</div>
